import {all, fork} from 'redux-saga/effects';
import provideStrapiTokenToServiceFlow from './sagas/provideStrapiTokenToServiceFlow';
import linkViewModalFlow from './sagas/linkViewModalFlow';
import postFeedback from './sagas/postFeedback';

const applicationWatcher = function* applicationWatcher() {
    yield all([
        fork(provideStrapiTokenToServiceFlow),
        fork(linkViewModalFlow),
        fork(postFeedback),
    ]);
};

export default applicationWatcher;
